import { RootState } from '../..';
import { ContestParticipant } from './types';

export const selectMyContestParticipant = (state: RootState): ContestParticipant => {
    return state.user.contestParticipant.myContestParticipant;
};
export const selectContestParticipants = (state: RootState): ContestParticipant[] => {
    return state.user.contestParticipant.contestParticipants;
};
export const selectLoadingParticipant = (state: RootState): boolean => {
    return state.user.contestParticipant.loading;
};
